import { combineReducers } from 'redux';
import App from '@iso/redux/app/reducer';
import Auth from '@iso/redux/auth/reducer';
import User from '@iso/redux/user/reducer';
import Transactions from '@iso/redux/transactions/reducer';
import ThemeSwitcher from '@iso/redux/themeSwitcher/reducer';
import LanguageSwitcher from '@iso/redux/languageSwitcher/reducer';

export default combineReducers({
  Auth,
  User,
  Transactions,
  App,
  ThemeSwitcher,
  LanguageSwitcher,
});
